import { Alert } from "@mantine/core";

import { IconAlertCircle } from "@tabler/icons-react";

import { TextWrapper } from "@/components/TextWrapper";

import { getProcedureCodeWarningOn, ServiceDateKey } from "../utils/procedure-code-effective-dates";

interface ProcedureCodeDateWarningProps {
  code: string;
  /** Service date as the service's local `yyyy-MM-dd`; without it no warning shows. */
  serviceDate: ServiceDateKey | undefined;
  "data-testid"?: string;
}

/**
 * Non-blocking note for a procedure code selected outside its billable dates. Renders nothing when
 * the code is billable on the service date.
 */
export default function ProcedureCodeDateWarning({
  code,
  serviceDate,
  "data-testid": dataTestId,
}: ProcedureCodeDateWarningProps) {
  const warning = getProcedureCodeWarningOn(code, serviceDate);
  if (!warning) return null;

  return (
    <Alert p="xs" color="yellow" data-testid={dataTestId} icon={<IconAlertCircle size={16} />}>
      <TextWrapper size="sm" c="gray.9">
        {warning}
      </TextWrapper>
    </Alert>
  );
}
